import React from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { ADMIN_SETUP_STEPS } from "./onboardingSteps";

const CheckIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M3.5 8.5l3 3 6-7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const QuickSetupLayout = ({ currentStep, title, description, children }) => {
  const navigate = useNavigate();
  const current = ADMIN_SETUP_STEPS.find((step) => step.id === currentStep);

  return (
    <div className="onboarding-setup onboarding-setup--app">
      <div className="onboarding-setup__card">
        <ol className="onboarding-setup__app-steps" aria-label="Quick setup steps">
          {ADMIN_SETUP_STEPS.map((step) => {
            const state =
              step.id < currentStep
                ? "done"
                : step.id === currentStep
                ? "current"
                : "upcoming";
            const clickable = step.id <= currentStep;
            return (
              <li
                key={step.id}
                className={clsx("onboarding-setup__app-step", `is-${state}`)}
              >
                <button
                  type="button"
                  className="onboarding-setup__app-step-btn"
                  onClick={() => clickable && navigate(step.path)}
                  disabled={!clickable}
                  aria-current={state === "current" ? "step" : undefined}
                >
                  <span className="onboarding-setup__rail-index">
                    {state === "done" ? <CheckIcon /> : step.id}
                  </span>
                  <span className="onboarding-setup__app-step-copy">
                    <strong>{step.label}</strong>
                    <span>{step.hint}</span>
                  </span>
                </button>
              </li>
            );
          })}
        </ol>

        <header className="onboarding-setup__header">
          <p className="onboarding-setup__eyebrow">
            Step {currentStep} of {ADMIN_SETUP_STEPS.length}
            {current ? ` · ${current.label}` : ""}
          </p>
          <h1>{title}</h1>
          {description ? (
            <p className="onboarding-setup__lead">{description}</p>
          ) : null}
        </header>
        {children}
      </div>
    </div>
  );
};

export default QuickSetupLayout;
